import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
// import { WasteCollectorMenu } from './WasteCollectorMenu'
import { WasteCollectorMenuC } from './CustomersMenu'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../_metronic/helpers'
// import { UserManagementWrapper } from '../data-administration/data-admininstration-list/user-management/userManagementList'
import { UserManagementWrapperC } from '../data-administration/data-admininstration-list/user-management/userManagementListC'
// import { WasteCollectorPaymentList } from '../data-administration/data-admininstration-list/waste-collector-payment/wasteCollectorPaymentList'
import { WasteCollectorPaymentListC } from '../data-administration/data-admininstration-list/waste-collector-payment/wasteCollectorPaymentListC'
// import { SupplyLedgerReportWrapper } from '../data-administration/data-admininstration-list/supply-ledger/supplyLedgerReportList'
import { SupplyLedgerReportWrapperC } from '../data-administration/data-admininstration-list/supply-ledger/supplyLedgerReportListC'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Customers',
    path: '/apps/customers',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const WasteCollectorPageC = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<WasteCollectorMenuC />} />
        <Route
          path='waste-collectorc'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Customers</PageTitle>
              <UserManagementWrapperC />
            </SuspensedView>
          }
        />
        <Route
          path='paymentsc'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Receivables</PageTitle>
              <WasteCollectorPaymentListC />
            </SuspensedView>
          }
        />
        <Route
          path='supply-ledgerc'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Sales Ledger</PageTitle>
              <SupplyLedgerReportWrapperC />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default WasteCollectorPageC
